module.exports = __webpack_public_path__ + "img/qingshaonian_gzh.c16e9cc3.jpg";